/**
 * 图片路径工具函数
 * 统一管理图片资源的基础URL
 */

// 图片资源基础URL
const BASE_URL = 'https://static.renderg.com:6443/rendercool_dist'

/**
 * 获取完整的图片URL
 * @param {string} imagePath - 相对图片路径，如 '/images/banner.png'
 * @returns {string} 完整的图片URL
 */
export function getImageUrl(imagePath) {
  // 确保路径以 / 开头
  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`
  return `${BASE_URL}${normalizedPath}`
}

/**
 * 获取图片基础URL
 * @returns {string} 基础URL
 */
export function getBaseUrl() {
  return BASE_URL
}

/**
 * 批量获取图片URL
 * @param {string[]} imagePaths - 图片路径数组
 * @returns {string[]} 完整图片URL数组
 */
export function getImageUrls(imagePaths) {
  return imagePaths.map(path => getImageUrl(path))
}

/**
 * 获取不同尺寸的图片URL（用于响应式图片）
 * @param {string} basePath - 基础图片路径，如 '/images/banner'
 * @param {string[]} suffixes - 尺寸后缀数组，如 ['', '-md', '-sm', '-xs']
 * @param {string} extension - 文件扩展名，默认为 '.png'
 * @returns {Object} 包含不同尺寸图片URL的对象
 */
export function getResponsiveImageUrls(basePath, suffixes = ['', '-md', '-sm', '-xs'], extension = '.png') {
  const urls = {}
  const sizeNames = ['default', 'md', 'sm', 'xs']
  
  suffixes.forEach((suffix, index) => {
    const sizeName = sizeNames[index] || `size${index}`
    urls[sizeName] = getImageUrl(`${basePath}${suffix}${extension}`)
  })
  
  return urls
}

// 导出默认配置
export default {
  BASE_URL,
  getImageUrl,
  getBaseUrl,
  getImageUrls,
  getResponsiveImageUrls
}